import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ChangePassword() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [curr, setCurr] = useState("");
  const [nw, setNw] = useState("");
  const [nw2, setNw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw !== nw2) { toast.error("Passwords don't match"); return; }
    if (nw.length < 8) { toast.error("Password must be 8+ characters"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: curr, new_password: nw });
      toast.success("Password updated 🎉");
      await refresh();
      navigate("/dashboard", { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-950 flex items-center justify-center p-6" data-testid="change-password-page">
      <div className="w-full max-w-md border border-neutral-800 p-8 md:p-10 bg-neutral-950">
        <KeyRound className="w-6 h-6 text-[#00C97A] mb-4" strokeWidth={1.5} />
        <div className="text-xs uppercase tracking-[0.25em] text-neutral-500 mb-2">First sign-in</div>
        <h2 className="font-heading text-3xl font-semibold tracking-tight text-white">Set a new password</h2>
        <p className="text-sm text-neutral-400 mt-2 mb-6">For security, choose your own password before continuing.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-neutral-500">Current (temporary) password</Label>
            <Input type="password" value={curr} onChange={(e) => setCurr(e.target.value)} data-testid="cp-current" className="mt-2 rounded-none bg-neutral-900 border-neutral-800 h-11" required />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-neutral-500">New password</Label>
            <Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} data-testid="cp-new" className="mt-2 rounded-none bg-neutral-900 border-neutral-800 h-11" required />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-neutral-500">Confirm new password</Label>
            <Input type="password" value={nw2} onChange={(e) => setNw2(e.target.value)} data-testid="cp-confirm" className="mt-2 rounded-none bg-neutral-900 border-neutral-800 h-11" required />
          </div>
          <Button type="submit" disabled={loading} data-testid="cp-submit" className="w-full h-11 rounded-none bg-[#00C97A] hover:bg-[#00B26B] text-black">
            {loading ? "Updating…" : "Update & continue"}
          </Button>
        </form>
      </div>
    </div>
  );
}
